export const alertTypes = [
  {
    id: 'emergency',
    index: 10,
    description: 'Emergency',
    disabled: true,
    tooltipDescription: 'An incident requiring police, fire, or medical dispatch.',
    methods: ['Phone', 'Sms'],
    icon: 'alarm.svg',
  },
  {
    id: 'indoorPersonDetected',
    index: 11,
    description: 'Indoor Person Detected',
    disabled: true,
    tooltipDescription: 'Agents detected a Person indoors.',
    methods: ['Phone', 'Sms'],
    icon: 'view.svg',
  },
  {
    id: 'unknownPerson',
    index: 20,
    description: 'Unknown Person',
    tooltipDescription: 'Someone on your property that doesn’t appear to be a delivery person, service worker, or passerby.',
    methods: ['Sms'],
    icon: 'stranger.svg',
  },
  {
    id: 'delivery',
    index: 30,
    description: 'Delivery',
    methods: ['Sms'],
    tooltipDescription: 'Someone dropping something off at your property, such as a package, mail, or food.',
    icon: 'delivery.svg',
  },
  {
    id: 'serviceWorker',
    index: 40,
    description: 'Service Worker',
    methods: ['Sms'],
    tooltipDescription: 'Someone using tools or equipment for what appears to be legitimate work.',
    icon: 'service_worker.svg',
  },
  {
    id: 'vsgModeStatus',
    index: 50,
    description: 'Virtual Security Guard Armed/Disarmed',
    methods: ['Sms'],
    tooltipDescription: 'We’ll send a text message every time the service is turned on or off.',
    icon: 'virtual_security_guard_blue.svg',
  },
];

export const getAlertTypes = () => alertTypes;

export const ownerContact = 'OWNER';

export const alertMethods = [
  {
    id: 'Phone',
    description: 'Call',
  },
  {
    id: 'Sms',
    description: 'Text',
  },
];

export const eventSummaryFrequency = [
  {
    label: 'Daily',
    value: 'DAY',
  },
  {
    label: 'Weekly',
    value: 'WEEK',
  },
  {
    label: 'Monthly',
    value: 'MONTH',
  },
];
